module.exports = __webpack_public_path__ + "img/candado.93d80834.svg";